module.exports = __webpack_public_path__ + "static/grafika7-4cb3709cfc622a7ecbe0bca2ff0ddebf.png";